import * as types from '../../action-types';
import AxiosCall from '../../../utils/axios';
import ErrorHandler from '../../../utils/error-handler';

export const addEducationStart = () => ({
  type: types.ADD_EDUCATION_START
});

export const addEducationSuccess = payload => ({
  type: types.ADD_EDUCATION_SUCCESS,
  payload
});

export const addEducationFail = payload => ({
  type: types.ADD_EDUCATION_FAIL,
  payload
});

export const addEducationCleanup = () =>({
  type: types.ADD_EDUCATION_CLEANUP
});

export const addEducation = payload => async dispatch => {
  try {

    dispatch(addEducationStart());
    const requestObj = {
      path: "educations",
      method: "POST",
      data: payload,
    }
    const  res  = await AxiosCall(requestObj);
    dispatch(addEducationSuccess(res.data));
  } catch (err) {
    const error = ErrorHandler(err);
    dispatch(addEducationFail(error));
  }
}
